// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39f7e255","469":"d20cdb03"}[chunkId] + ".chunk.js";
};